import { useState } from "react";
import { useSnackbar } from "notistack";
import Modal1 from "../../components/DIsplay/Modal/Modal1";
import Button1 from "../../components/form/Button1";
import approvePriceFreeze from "../../controllers/booking/approvePriceFreeze";

export default function ApproveFreezeOrder({ open, setOpen, callback }) {
  const [loading, setLoading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();

  const priceFreezeId =
    typeof open === "object" ? open?.priceFreezeId : open;
  const status = typeof open === "object" ? open?.status : "APPROVED";
  const isDecline = status === "DECLINED";

  async function handleSubmit() {
    if (!priceFreezeId) {
      enqueueSnackbar("Price freeze ID is missing", { variant: "error" });
      return;
    }

    setLoading(true);
    const res = await approvePriceFreeze({
      priceFreezeId,
      status,
    });
    setLoading(false);

    if (res.return) {
      enqueueSnackbar(
        res.msg ||
          (isDecline ? "Price freeze declined" : "Price freeze approved"),
        { variant: "success" },
      );
      setOpen(false);
      callback?.();
    } else {
      enqueueSnackbar(res.msg, { variant: "error" });
    }
  }

  return (
    <Modal1 open={Boolean(open)} setOpen={setOpen}>
      <div className="flex max-w-[400px] flex-col gap-4 p-10">
        <h5 className="self-center">
          {isDecline ? "Decline Price Freeze" : "Approve Price Freeze"}
        </h5>
        <p className="py-4">
          {isDecline
            ? "Are you sure you want to decline this price freeze order? This action cannot be undone."
            : "Are you sure you want to approve this price freeze order? This action cannot be undone."}
        </p>
        <div className="flex gap-4">
          <Button1
            className="flex-1 !btn-theme-light"
            onClick={() => setOpen(false)}
          >
            Cancel
          </Button1>
          <Button1
            className={isDecline ? "!bg-red-500" : ""}
            loading={loading}
            onClick={handleSubmit}
          >
            Confirm
          </Button1>
        </div>
      </div>
    </Modal1>
  );
}
